import React, { useEffect, useState } from "react";

import { connect } from "react-redux";

import Select from "./index";

function Entity({ config, dispatch, name = "entity", ...props }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (config.length) {
      const items = {};
      config.forEach((entity) => {
        items[entity.id] = `${entity.id} - ${entity.name}`;
      });
      setItems(items);
    }
  }, [config]);

  return <Select label="Entity" items={items} name={name} {...props} />;
}

const mapStateToProps = (state) => ({
  config: state.prp.config.length ? state.prp.config : state.prp.me.config,
});

export default connect(mapStateToProps)(Entity);
